"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getQueryString;

function getQueryString() {
  return window.location.search;
}

module.exports = exports.default;